import axios from 'axios';

const PREPROCESS_BASE_URL =
  import.meta.env.VITE_OCR_PREPROCESS_URL ??
  'https://preprocess-service-448580105039.asia-northeast3.run.app';

export interface OcrCornerPoint {
  x: number;
  y: number;
}

export interface OcrCornersResponse {
  corners?: OcrCornerPoint[];
}

/** 레거시 `requestOcrCorners` — 처방 이미지 모서리 좌표 */
export const preprocessService = {
  getCornersFromUrl: async (imageUrl: string): Promise<OcrCornersResponse> => {
    const response = await axios.post<OcrCornersResponse>(
      `${PREPROCESS_BASE_URL}/pipeline/corners/url`,
      { imageUrl },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        timeout: 600_000,
      },
    );
    return response.data;
  },
};
